import { render, staticRenderFns } from "./desktopDeclination1.vue?vue&type=template&id=ad99e84e&scoped=true&"
import script from "./desktopDeclination1.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination1.vue?vue&type=script&lang=ts&"
import style0 from "./desktopDeclination1.vue?vue&type=style&index=0&id=ad99e84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad99e84e",
  null
  
)

export default component.exports